import {useQuery} from '@tanstack/react-query';
import {client,result} from './api';
import {cardStatus,cardSummary,levelRows,sourceRows,type PriceCard,type PriceLevels,type PriceRow} from './resourcePrice';

function Rows({rows}:{rows:PriceRow[]}) {
  return <dl className="price-card-rows">{rows.map(row=><div key={row.label}><dt>{row.label}</dt>
    <dd>{row.value}{row.note&&<small className={row.note.startsWith('SHA-256')?'source-hash':undefined}>{row.note}</small>}</dd></div>)}</dl>;
}

/** Базисная цена, индекс и текущая цена — рядом, но раздельно. */
export function PriceLevelLines({levels,currency,unit}:{levels:PriceLevels;currency?:string;unit?:string}) {
  return <Rows rows={levelRows(levels,currency,unit)}/>;
}

export function ResourcePriceCard({card}:{card:PriceCard}) {
  const summary=cardSummary(card);
  return <section className={`price-card price-card-${card.status}`} aria-label="Карточка цены ресурса">
    <strong>{cardStatus[card.status]}{card.code?` · ${card.code}`:''}</strong>
    {summary&&<p className="price-card-reason" role="note">{summary}</p>}
    {card.unit_price!=null&&<PriceLevelLines levels={card} currency={card.currency} unit={card.price_unit}/>}
    <Rows rows={sourceRows(card)}/>
    {card.download_url&&<a href={card.download_url}>Скачать исходник версии цен</a>}
  </section>;
}

/** The card of a saved resource; an unsaved edit is never described with the old price. */
export function SavedResourcePrice({workId,version,position,code}:{workId:string;version:number;position:number;code:string}) {
  const cards=useQuery({queryKey:['resource-price-cards',workId,version],
    queryFn:()=>result(client.GET('/api/v1/works/{work_id}/resource-price-cards',{params:{path:{work_id:workId}}}))});
  if(cards.error)return <p role="alert">{String(cards.error)}</p>;
  const card=cards.data?.find(item=>item.position===position);
  if(!card)return null;
  if((card.code||'')!==code)return <p className="muted">Карточка цены обновится после сохранения сведений.</p>;
  return <ResourcePriceCard card={card}/>;
}
